'use client';

import { useRouter, usePathname, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';
import { cn } from '@/lib/utils/cn';
import { useI18n } from '@/lib/i18n/context';

interface Category { id: string; name: string; alias: string; classify: number | null; }

interface Props {
  categories: Category[];
  currentSort: string;
}

export function CategoryFilter({ categories, currentSort }: Props) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const { t } = useI18n();
  const SORT_OPTIONS = [
    { value: 'newest', label: t.home.sortNewest },
    { value: 'trending', label: t.home.sortTrending },
    { value: 'popular', label: t.home.sortPopular },
  ];

  const setParam = useCallback((key: string, value: string | null) => {
    const params = new URLSearchParams(searchParams.toString());
    if (value) params.set(key, value); else params.delete(key);
    router.push(`${pathname}?${params.toString()}`, { scroll: false });
  }, [router, pathname, searchParams]);

  const currentCat = searchParams.get('category');

  return (
    <div className="top-[60px] z-40 bg-surface-950/95 backdrop-blur-md py-3 border-b border-white/5 -mx-4 px-4">
      <div className="flex items-center gap-2 overflow-x-auto scrollbar-none">
        {/* Sort */}
        {SORT_OPTIONS.map(opt => (
          // <button
          //   key={opt.value}
          //   onClick={() => setParam('sort', opt.value)}
          //   className={cn(
          //     'flex-shrink-0 px-4 py-1.5 rounded-2xl text-sm font-medium transition-all',
          //     currentSort === opt.value
          //       ? 'bg-brand-600 text-white shadow-lg shadow-brand-600/25'
          //       : 'text-gray-400 hover:text-white hover:bg-surface-800'
          //   )}
          // >
          //   {opt.label}
          // </button>
          <a href={`/?sort=${opt.value}`} className={cn(
              'flex-shrink-0 px-4 py-1.5 rounded-2xl text-sm font-medium transition-all',
              currentSort === opt.value
                ? 'bg-brand-600 text-white shadow-lg shadow-brand-600/25'
                : 'text-gray-400 hover:text-white hover:bg-surface-800'
            )}>{opt.label}</a>
        ))}

        <div className="w-px h-5 bg-surface-700 flex-shrink-0 mx-1" />

        {/* All */}
        {/* <button
          // Reset both category and sort when clicking "All"
          onClick={() => setParam('sort', null) || setParam('category', null)}
          className={cn(
            'flex-shrink-0 px-4 py-1.5 rounded-2xl text-sm font-medium transition-all',
            !currentCat
              ? 'bg-white/10 text-white'
              : 'text-gray-400 hover:text-white hover:bg-surface-800'
          )}
        >
          {t.home.allCategories}
        </button> */}
        <a href={`/`} className={cn(
            'flex-shrink-0 px-4 py-1.5 rounded-2xl text-sm font-medium transition-all',
            !currentCat
              ? 'bg-white/10 text-white'
              : 'text-gray-400 hover:text-white hover:bg-surface-800'
          )}>{t.home.allCategories}</a>

        {/* Categories */}
        {categories.map(cat => (
          <button
            key={cat.id}
            onClick={() => setParam('category', cat.alias)}
            className={cn(
              'flex-shrink-0 px-4 py-1.5 rounded-2xl text-sm font-medium transition-all',
              currentCat === cat.alias
                ? 'bg-white/10 text-white'
                : 'text-gray-400 hover:text-white hover:bg-surface-800'
            )}
          >
            {cat.name}
          </button>
        ))}
      </div>
    </div>
  );
}
